define('rebrush/components/cart/ajax',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'cartware/components/Dispatcher',
	'gigaset/spinner',
	'gigaset/fx-engine',
	'cartware/components/Utilities',
	'json!rebrush/handles/default.json',
	'text!shoptheme/templates/magnific-popup/default.html',
	'magnific-popup',
	'bootstrap-button'
], function(
	$,
	_,
	Component,
	BEM,
	ComponentDispatcher,
	Spinner,
	FX,
	Utils,
	Handles,
	PopupHtml
) {
	var popupTemplate = null;


	return Component.create({
		miniCart:		null,
		cart:			null,
		modalMainClasses: null,
		$init: function() {
			var self = this,
				$body = $(document.body);

			this.miniCart = BEM.block('mini-cart');
			this.cart = BEM.block('cart');

			this._prepareForm();

			// Bind add to cart buttons / links
			$body.on('click', '[data-ajax-add-to-cart]', _.bind(function(e) {
				e.preventDefault();

				var link = $(e.currentTarget);

				if (link.hasClass('btn-disabled')) {
					return false;
				}

				var url = link.attr('href') || link.data('add-to-cart-url'),
					container = link.closest('.b_product-item__container'),
					data = link.data('ajax-add-to-cart'),
					hasRequiredOptions = _.get(data, 'hasRequiredOptions');

				if (hasRequiredOptions && $body.hasClass('catalog-product-view')) {
					return true;
				}

				Spinner.add(container.length === 0 ? 'body' : container);
				self._sendRequest(
					url,
					{ 'isAjax': 1, 'qty': link.data('order-qty') },
					function(response) {
						if (response.success) {
							// Disable add to cart button in product minicard (category page only).
							var inTheCartText = link.attr('data-text-after-add-to-cart');
							if (inTheCartText) {
								link.addClass('btn-disabled');
								link.html('<span class="icon-rebrush-ui-check"></span>' + inTheCartText);
							}
						}
						self._onAddSuccess(response);
					}
				);
				$.magnificPopup.close();
			}, this));

			// Bind cart move to wishlist links
			$body.on('click', '.cart-table .move-to-wishlist', _.bind(function(e) {
				e.preventDefault();
				var link = $(e.currentTarget),
					url = link.attr('href');

				Spinner.add('#shopping-cart-table');
				self._sendRequest(url, { 'isAjax': 1 });
			}, this));

			// Bind cart view qty selects
			$body.on('change', '.cart-table select.qty', function(e) {
				var form = self.cart.find('form'),
					select = $(e.target),
					url = form.attr('action'),
					data = form.serialize() + '&content=cart',
					xhr = self._sendRequest(url, data, self._onUpdateSuccess);

				Spinner.add('#shopping-cart-table');

				xhr.then(function(response) {
					if (_.isObject(response)) {
						if (response.error) {
							select.val(select.data('__original_value'));

							if (select.data('select2')) {
								select.trigger('change.select2');
							}
						}
					}
					self._rememberCartQty();
				});
			});


			// Bind cart view remove links
			$body.on('click', '.cart-table a.remove-from-cart', function(e) {
				e.preventDefault();
				var url = $(e.currentTarget).attr('href'),
					data = $('.b_cart input[name="form_key"]').serialize() + '&content=cart';

				Spinner.add('#shopping-cart-table');
				e.preventDefault();
				self._sendRequest(url, data, self._onRemoveSuccess);
			});

			this._rememberCartQty();
		},

		_rememberCartQty: function() {
			$('.cart-table select.qty').each(function() {
				var select = $(this);

				select.data('__original_value', select.val());
			});
		},

		/**
		 * Overwrite productAddToCartForm submit function
		 * @private
		 */
		_prepareForm: function() {
			if ($(document.body).hasClass('wishlist-index-configure') !== true) { // quick fix to prevent ajax add2cart on wishlist configure product view page
				var self = this,
					formObj = _.get(window, 'productAddToCartFormOld', _.get(window, 'productAddToCartForm'));

				if (!formObj) {
					return;
				}

				formObj.submit = function () {
					if (this.validator.validate()) {
						var form = $(this.form),
							url = form.attr('action');

						Spinner.add();
						self._sendRequest(url, form.serialize(), self._onAddSuccess);
					}
				};
			}
		},

		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		/**
		 * Send ajax request
		 *
		 * @param url
		 * @param data
		 * @param onSuccessCallback
		 * @private
		 */
		_sendRequest: function(url, data, onSuccessCallback) {
			var self = this;

			data = data || {};

			// add isAjax param to avoid caching problems
			if (url.indexOf('isAjax=1') === -1 && typeof data === 'string' && data.indexOf('isAjax=1') === -1) {
				url += url.indexOf('?') === -1 ? '?isAjax=1' : '&isAjax=1';
			}

			var xhr = $.ajax(url, {
				method: 'POST',
				data: data
			}).always(function() {
				Spinner.remove();
			}).then(_.bind(function(response, status, xhr) {
				var responseHandles = $.parseJSON(xhr.getResponseHeader('X-Magento-Handles') || '[]');

				if (responseHandles.indexOf('gigaset_dealerpos_checkout_productview') > -1 &&
					responseHandles.indexOf('catalog_product_view') < 0
				) {
					responseHandles.push('catalog_product_view');
				}

				var pageHandles = Utils.getPath(window, 'gigaset.handles');

				if (responseHandles.indexOf('checkout_cart_index') < 0 &&
					pageHandles.indexOf('checkout_cart_index') > -1
				) {
					responseHandles.push('checkout_cart_index');
				}

				var _isResponseHtml = (typeof response === 'string');
				response = _isResponseHtml ? { body: response } : response;

				if (response.redirect) {
					window.location = response.redirect;
					return;
				}

				if (response.success === true && typeof onSuccessCallback === 'function') {
					onSuccessCallback(response);
				}
				if (response.mini_cart) {
					self.miniCart.replaceWith(response.mini_cart);
					self.miniCart = BEM.block('mini-cart');
				}
				if (response.cart) {
					self.cart.replaceWith(response.cart);
					self.cart = BEM.block('cart');
				}
				if (response.body || response.message) {
					var newModalMainClasses = (responseHandles.indexOf('catalog_product_view') > -1) ?
						['container-size', 'shadow', 'mfp-product-view'] :
						['shadow'];

					var onOpen = function () {

						var onDone = function() {
							$(document.body).scrollTop($('.mfp-content').offset().top - 60);
							self.hub.trigger('cartware_cart/add-after', response);
						};

						if (_isResponseHtml === true || 'body' in response) {
							var handles = _.intersection([
								'catalog_product_view',
								'PRODUCT_TYPE_configurable',
								'gigaset_dealerpos_checkout_productview',
								'catalog_product_customoption_print',
								'gigaset_wheretobuy_product_view'
							], responseHandles);


							handles.push('cartware_cart_popup_open');

							var dispatcher = new ComponentDispatcher({
								handles: handles
							});

							dispatcher.applyHandles(_.assign({}, Handles), function(_component, isLast) {
								if (isLast) {
									onDone();
								}
							});

							// TODO use `self.hub.trigger()` here instead for event and component dispatching
							$(document).trigger('cartware_cart/modal/open', [response]);

							self._prepareForm();
						} else {
							onDone();
						}
					};

					if ($.magnificPopup.instance.isOpen) {
						if (self.modalMainClasses) {
							_.forEach(self.modalMainClasses, function(className) {
								$.magnificPopup.instance.wrap.removeClass(className);
								$.magnificPopup.instance.bgOverlay.removeClass(className);
							});
						}

						_.forEach(newModalMainClasses, function(className) {
							$.magnificPopup.instance.wrap.addClass(className);
							$.magnificPopup.instance.bgOverlay.addClass(className);
						});

						onOpen();
					}

					self.modalMainClasses = newModalMainClasses;

					$.magnificPopup.open({
						mainClass: self.modalMainClasses.join(' '),
						fixedContentPos: true,
						items: {
							src: this._renderPopup({
								body: response.body ? response.body : response.message,
								displayCloseButton: true
							}),
							type: 'inline'
						},
						callbacks: {
							open: onOpen
						}
					});

					if ($.magnificPopup.instance.isOpen) {
						$(document.body).scrollTop($('.mfp-content').offset().top - 60);
					}
				} else {

					var handles = _.intersection([
						'checkout_cart_index'
					], responseHandles);

					var dispatcher = new ComponentDispatcher({
						handles: handles
					});

					dispatcher.applyHandles(_.assign({}, Handles));

					$(document).trigger('cartware_cart/add-after', response);
				}

				return response;
			}, this));

			return xhr;
		},
		_onAddSuccess: function(response) {
			if ('dataLayer' in window) {
				var dataLayer = window.dataLayer;
				var ecommerce = {};

				if (response.tracking) {
					ecommerce = JSON.parse(response.tracking);
				}

				// reset data layer add-to-cart item data
				dataLayer.push({
					'ecommerce': undefined
				});

				if (Object.keys(ecommerce).length !== 0) {
					dataLayer.push({'event':'add-to-cart', ecommerce});
				} else {
					dataLayer.push({'event':'add-to-cart'});
				}
			}
			$(document).trigger('cartware_cart/add', response);
		},
		_onRemoveSuccess: function(response) {
			$(document).trigger('cartware_cart/remove', response);
		},
		_onUpdateSuccess: function(response) {
			$(document).trigger('cartware_cart/update', response);
		},
	});
});

